"use client"

import { createContext, useContext, useMemo, type ReactNode } from "react"
import type { DomainKey } from "@/lib/domain"

const DomainContext = createContext<{ domainKey: DomainKey } | null>(null)

export function DomainProvider({
  domainKey,
  children,
}: {
  domainKey: DomainKey
  children: ReactNode
}) {
  const value = useMemo(() => ({ domainKey }), [domainKey])
  return (
    <DomainContext.Provider value={value}>
      {children}
    </DomainContext.Provider>
  )
}

export function useDomain() {
  const ctx = useContext(DomainContext)
  if (!ctx) throw new Error("useDomain must be used within DomainProvider")
  return ctx
}
